import { AxiosInstance } from 'axios';
import { Purchase, PurchaseRequest } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'purchase';

export class PurchaseApi {
  private apiInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getUserPurchases(userId: string): Promise<Array<Purchase>> {
    await simulate();
    const response = await this.apiInstance.get(`/${userId}`);

    return response.data;
  }

  async getProductIntent(formValues: PurchaseRequest): Promise<string> {    
    await simulate();

    const response = await this.apiInstance.post('/intent', formValues);

    return response.data;
  }

  async getFreeProducts(formValues: PurchaseRequest): Promise<Purchase> {    
    await simulate();

    const response = await this.apiInstance.post('/free', formValues);

    return response.data;
  }
}
